


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import auth from '@/libs/auth';

import AuthLayout from '@/components/AuthLayout.vue';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';
import api from '@/libs/api';
import { mapMutations } from 'vuex';

@Component({
  components: {
    ValidationObserver,
    AuthLayout,
    FormInput,
    Button,
  },
  methods: mapMutations(['setUser']),
})
export default class TwoFactorAuth extends Vue {
  @Prop(String) email!: string;
  @Prop(String) password!: string;
  @Prop(String) imageCaptcha!: string;
  @Prop(String) captcha!: string;

  twofaCode = '';
  loading = false;
  errors = {
    twofaCode: '',
  };

  $refs!: {
    code: HTMLInputElement;
  }

  setUser!: (data: unknown) => Promise<void>;

  mounted() {
    this.$refs.code.focus();
  }

  async loginWithTwoFA() {
    try {
      this.loading = true;

      const uuid = Vue.$cookies.get('browser_uuid');
      const { data } = await api.post('/login', {
        email: this.email,
        password: this.password,
        // captcha: this.captcha,
        twofaCode: this.twofaCode,
      }, { headers: { 'x-browser-id': uuid } });

      auth.setUser(data.data);
      this.setUser(data.data);
      if (typeof this.$route.query.redirect === 'string') {
        this.$router.replace(this.$route.query.redirect);
      } else {
        this.$router.push('/');
      }
    } catch (err) {
      this.loading = false;
      const { status } = err.response;

      if (status === 423) {
        this.$router.push({
          name: 'Locked',
          params: {
            email: this.email,
          },
        });
      } else {
        err.response.data.error.errors.forEach((item: any) => {
          if (item.reason === 'InvalidTwoFactorOTP') {
            this.errors.twofaCode = item.message;
          }
        });
      }
    }
  }
}
